// Web module: monitoring (lane L2). Entities: monitor, test_run, finding, monitor_exclusion.
//   /monitors        MonitoringPage: Drata summary strip, status tabs, filter rail, table with Test now and the
//                    enable / disable toggle, bulk Test now / Enable / Disable, Download CSV
//   /monitors/:id    MonitorDetailPage: Overview, Failing resources, Exclusions, Run history (snapshot download),
//                    Controls, Settings, History, Notes
// Test runs, findings and exclusions keep the generic list and detail pages (reachable from the test detail tabs).
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    monitor: {
      ListPage: lazyComponent(() => import('./MonitoringPage'), 'MonitoringPage'),
      DetailPage: lazyComponent(() => import('./MonitorDetailPage'), 'MonitorDetailPage'),
    },
  },
}
